var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"report-button --base-color --underline-effect",on:{"click":_vm.showReportModal}},[_vm._v("report")])}
var staticRenderFns = []

export { render, staticRenderFns }